import { render, staticRenderFns } from "./RefundTransactionsListView.vue?vue&type=template&id=63c66c1c&"
import script from "./RefundTransactionsListView.vue?vue&type=script&lang=js&"
export * from "./RefundTransactionsListView.vue?vue&type=script&lang=js&"
import style0 from "./RefundTransactionsListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports